export default {
  newDesign: true,
  parameters: {
    landing_id: "LatDesQvsC",
    segment: 44,
    success_page: "success_long",
  },
  title:
    "¡Ayúdanos a crear un plan creativo personalizado para tu hijo! | Kodland",
  downtimeUrl: "https://www.kodland.org/es",
  startPage: {
    title: "¡Ayúdanos a crear un plan creativo personalizado para tu hijo!",
    subtitle:
      "Esto tomará de 1 a 2 minutos y ayudará a elegir el formato y programa ideales 💙",
    image: {
      url: "/welcome/latam_design_desk_v2.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/latam_design_mob_v2.png",
      style: {
        width: "100%",
      },
    },
    button: "Presiona para continuar 🚀",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Lamentablemente, las tabletas y los teléfonos no son adecuados para nuestras clases. ¡Esperamos verte en nuestras lecciones en otra ocasión!",
  },
  quizRotateBySteps: {
    1: {
      question: "¿Qué quieres que tu hijo obtenga del dibujo y la creatividad?",
      answers: [
        {
          answer: "Hobby y creatividad 🎨",
          distribution_tag_question: [120],
        },
        {
          answer: "Preparación profesional 💼",
          distribution_tag_question: [120],
        },
        {
          answer: "Menos pantallas, más provecho 📱",
          distribution_tag_question: [120],
        },
        {
          answer: "Confianza y socialización 🤝",
          distribution_tag_question: [120],
        },
      ],
    },
    2: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_design_tutors.png",
      subtitle:
        "Nuestros profesores experimentados crearán un plan de estudios adaptado a cualquiera de estos objetivos 💙",
      button: "¡Genial!",
    },
    3: {
      question: "¿Qué prefiere crear tu hijo?",
      answers: [
        "Personajes y cómics 🎭",
        "Animación y cartoons 🎬",
        "Paisajes y animales 🌿",
        "De todo un poco 🎨",
      ],
    },
    4: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_design_recommendations.png",
      subtitle:
        "78% de nuestros estudiantes comienzan a dibujar sus personajes favoritos ya en el primer mes del curso. Y esto es lo que dicen los padres:",
      button: "Continuar ➡️",
    },
    5: {
      question: "¿Qué modalidad de aprendizaje le atrae más?",
      answers: [
        "Dibujo tradicional (papel, lápices) ✏️",
        "Dibujo digital (tableta, computadora) 💻",
        "Quiere probar otras áreas: animación, 3D, diseño gráfico 🚀",
        "No sabe, quiere experimentar",
      ],
    },
    6: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_design_courses.png",
      subtitle:
        "¡En Kodland lo tenemos todo! Cursos para niños y adolescentes: arte digital, dibujo, modelado 3D y diseño gráfico 🎨",
      button: "¿Qué más?",
    },
    7: {
      question: "¿Por qué prefieres clases online?",
      answers: [
        "No hay cursos locales 🏙️",
        "Horarios flexibles ⏰",
        "Mejores profesores 👨‍🏫",
        "Más tecnologías digitales 💻",
        "Otro motivo ✨",
      ],
    },
    8: {
      question: "¿Qué formato prefieres?",
      answers: [
        "Individual 👤",
        "Grupo pequeño (hasta 5) 👥",
        "Grupo grande 🎓",
        "Autoaprendizaje con apoyo 📚",
        "Necesito recomendación 🤔 ",
      ],
    },
    9: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_design_kids_drawings.png",
      subtitle:
        "¡Perfecto! Elegir el formato nos ayuda a crear clases que tu hijo realmente disfrutará 💙",
      button: "¡Muy bien!",
    },
    10: {
      question: "¿Con qué cuenta tu hijo para dibujar?",
      subtitle: "No te preocupes si falta algo, ¡se puede empezar sin todo!",
      answers: [
        "Tableta con stylus ✏️",
        "Tableta sin stylus 📱",
        "Materiales tradicionales 🎨",
        "Nada aún, vamos a comprar 🛒",
      ],
    },
    11: {
      question:
        "¿Cómo evalúa el nivel actual de habilidades de su hijo en dibujo o creatividad?",
      answers: [
        "Principiante, solo prueba 🌱",
        "Aficionado, dibuja por placer 🎨",
        "Buen nivel 👍",
        "Orientado profesionalmente 🎯",
      ],
    },
    12: {
      question: "¿Qué han probado ya para desarrollar habilidades creativas?",
      answers: [
        "Autodidacta (YouTube, libros) 📚",
        "Otros cursos online 💻",
        "Escuelas offline 🏫",
        "Nada aún 🆕",
        "Otro ✍️",
      ],
    },
    13: {
      question: "¿Qué actividades adicionales asiste su hijo actualmente?",
      answers: [
        "Deportes ⚽",
        "Música 🎵",
        "IT/matemáticas 💻",
        "Arte 🎨",
        "Nada 🆓",
      ],
    },
    14: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_design_progress.png",
      title: "Tu plan de aprendizaje creativo está listo 🎉",
      subtitle:
        "Empecemos con una clase gratuita donde conocerás nuestra escuela y tu hijo comenzará su viaje creativo. Todo online, con un profesor real de diseño.",
      button: "Me interesa 👀",
    },
    15: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_design_drawing_boy.png",
      title: "¿Y cómo acceder a la clase?",
      subtitle:
        "Esta clase gratuita está disponible por tiempo limitado. Solo tienes que completar el formulario en el siguiente paso y elegir el horario que más les convenga. Después, te pediremos confirmar tu participación por WhatsApp ¡y listo! 💙",
      button: "Reservar mi clase gratuita 🔥",
    },
    16: {
      title: "¿Cuántos años tiene tu hijo?",
      type: "age",
      button: "",
    },
    17: {
      title: "Inscríbete a una clase de prueba gratuita",
      type: "one-page-contacts",
      subtitle:
        "Conversemos, conoce nuestro método y descubre todo lo que tu hijo puede aprender con nosotros.",
      button: "Casi terminamos 🔥",
    },
    18: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    19: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    20: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    21: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
